<template>
  <div class="button-panel">
    <vf-button
      :size="ButtonSize.LARGE"
      :variant="ButtonVariant.SECONDARY"
      @click="handleCreateTokenClick"
      >{{ t('supplierAuthTokens.createAuthToken') }}</vf-button
    >
  </div>
  <supplier-tokens-table
    :fetch-tokens="fetchTokens"
    :supplier-id="supplierId"
    :tokens="tokens"
  />
  <create-supplier-token-modal
    ref="modalRef"
    :supplier-id="supplierId"
    @hide="fetchTokens"
  />
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';
  import { ButtonSize, ButtonVariant } from '../VfButton/VfButton.types';
  import { ref } from 'vue';
  import CreateSupplierTokenModal from '../CreateSupplierTokenModal/CreateSupplierTokenModal.vue';
  import SupplierTokensTable from '../SupplierTokensTable/SupplierTokensTable.vue';
  import { endpointsList } from '@/helpers';
  import { ISupplierAuthTokenDto } from 'types';
  import { useToast } from '@/composables/useToast';
  import axios from 'axios';

  const { t } = useI18n();
  const { createErrorToast } = useToast();

  const props = defineProps<{
    supplierId: string;
  }>();

  const modalRef = ref<InstanceType<typeof CreateSupplierTokenModal> | null>(
    null,
  );
  function handleCreateTokenClick() {
    modalRef.value?.show();
  }

  const tokens = ref<ISupplierAuthTokenDto[]>([]);
  async function fetchTokens(): Promise<void> {
    try {
      const response = await axios.get(
        endpointsList.supplierAuthTokens.getTokensForSupplier(props.supplierId),
      );
      tokens.value = response.data;
    } catch {
      createErrorToast(t('supplierAuthTokens.errors.errorGettingTokens'));
    }
  }
</script>

<style scoped>
  .button-panel {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 2rem;
  }
</style>
